module.exports = __webpack_public_path__ + "img/horizontal_6_6_5010.f685a575.png";